class InfiniteScrollNew extends HTMLElement {
  constructor() {
    super();

    this.productGrid = this.closest('.product-grid-container').querySelector('.product-grid');
    this.pagination = this.closest('.product-grid-container').querySelector('.pagination-wrapper');

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading');
    this.classList.add('disabled');

    const url = this.dataset.url;
    this.renderSectionFromFetch(url);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  renderSectionFromFetch(url) {
    fetch(`${url}&view=infinite`)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderPagination(html);
        this.renderProductGridContainer(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderPagination(html) {
    const pagination = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    if (pagination) {
      this.pagination.innerHTML = pagination.innerHTML;
    }
    else {
      this.pagination.remove();
    }
  }

  renderProductGridContainer(html) {
    const products = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
    this.productGrid.insertAdjacentHTML('beforeend', products.innerHTML);

    try {
      lazyVideoLoader.observe();
      updateStarRatings();  
    } catch (error) {
      console.log('Error:', error)
    }
  }
}

if (!customElements.get('infinite-scroll-new')) {
  customElements.define('infinite-scroll-new', InfiniteScrollNew);
}